module.exports = __webpack_public_path__ + "static/media/tudn_thumbnail.7dcfd1a0.png";